import { render, staticRenderFns } from "./AccordionElement.vue?vue&type=template&id=5615af76&"
import script from "./AccordionElement.vue?vue&type=script&lang=js&"
export * from "./AccordionElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports